import { useContext, useState } from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import {
  Box,
  Grid,
  Container,
  IconButton,
  InputAdornment,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { AuthContext } from 'contexts/AuthContext';
import Card from 'components/Card';
import Input from 'components/Input';
import Button from 'components/Button';
import logo from 'assets/logo.png';

const Login = () => {
  const { loading, login } = useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);
  const { control, handleSubmit } = useForm({
    defaultValues: {
      email: process.env.REACT_APP_DEV_EMAIL || '',
      senha: process.env.REACT_APP_DEV_SENHA || '',
    },
  });

  return (
    <form onSubmit={handleSubmit(login)}>
      <Container maxWidth="md">
        <Box
          height="100vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Card>
            <Grid container spacing={2}>
              <Grid item xs={12} textAlign="center">
                <Box
                  src={logo}
                  component="img"
                  objectFit="contain"
                  alt="Logo da Eprom"
                />
              </Grid>
              <Grid item xs={12}>
                <Input
                  name="email"
                  type="email"
                  label="E-mail"
                  control={control}
                />
              </Grid>
              <Grid item xs={12}>
                <Input
                  name="senha"
                  label="Senha"
                  control={control}
                  type={showPassword ? 'text' : 'password'}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          edge="end"
                          size="small"
                          onClick={() => setShowPassword(!showPassword)}
                          onMouseDown={(e) => e.preventDefault()}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} textAlign="end">
                <Button
                  size="small"
                  type="submit"
                  color="primary"
                  loading={loading}
                  variant="contained"
                  onClick={handleSubmit(login)}
                >
                  ENTRAR
                </Button>
              </Grid>
            </Grid>
          </Card>
        </Box>
      </Container>
    </form>
  );
};

export default Login;
